export function alphabeticalFilter() {
	const $filter = $(this)
	const $letters = $filter.children()

	const $tab = $filter.parent()
	const $list = $tab.find('.tag-list')
	const $letterGroups = $list.find('.list-title')
	const $arrowUp = $letterGroups.find('.ico.ico-arrow-up')

	$letters.on('click', function(e) {
		const $this = $(this)

		$letters.removeClass('is-current')
		$this.addClass('is-current')
		$list.removeClass('is-mini')
		$arrowUp.addClass('hidden')

		if ($this.hasClass('filter-all')) {
			$list.removeClass('is-mini')
			$letterGroups.removeClass('is-active').show()
			$arrowUp.removeClass('hidden')

			return
		}

		const letter = '\\' + $this.text()
		const $letterGroup = $letterGroups.filter('.list-' + letter)
		const $tagItems = $letterGroup.find('.tag-item')

		if ($tagItems.length <= 10) {
			$list.addClass('is-mini')
		}

		$letterGroups.removeClass('is-active').hide()
		$letterGroup.addClass('is-active').show()
	})
}


// WEBPACK FOOTER //
// ./src/desktop/scripts/modules.js